import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router'
import { Layers } from 'lucide-react'
import { Card, Empty, PageHeader, StatusBadge, Table, useAuth, type Column } from '@concours/ui'
import type { Competition } from '../../lib/competition-types'
import type { Paginated } from '../../lib/rbac-types'

/**
 * Moteur de sélection (phase 13) : choix du concours dont on configure le
 * parcours (étapes, disciplines, barèmes, règles de passage).
 */
export function SelectionPage() {
  const { session } = useAuth()
  const navigate = useNavigate()
  const list = useQuery({
    queryKey: ['admin', 'competitions', 'selection'],
    queryFn: () =>
      session.api
        .get<Paginated<Competition>>('/admin/competitions', { query: { perPage: 100 } })
        .then((r) => r.data),
  })
  const columns: Column<Competition>[] = [
    {
      key: 'reference',
      header: 'Référence',
      cell: (c) => <span className="mono">{c.reference}</span>,
    },
    { key: 'title', header: 'Concours', cell: (c) => <strong>{c.title}</strong> },
    { key: 'session', header: 'Session', cell: (c) => c.session },
    { key: 'seats', header: 'Places', numeric: true, cell: (c) => c.seats },
    {
      key: 'status',
      header: 'État',
      cell: (c) => <StatusBadge domain="competition" status={c.status} />,
    },
  ]
  return (
    <>
      <PageHeader
        eyebrow="Sélection"
        title="Parcours de sélection"
        description="Pour chaque concours : les étapes (écrit, physique, oral, vérifications…), leurs disciplines et barèmes, et les règles de passage versionnées. Aucune règle officielle n’est prédéfinie : tout se configure ici, puis se valide."
      />
      <Card>
        <Table
          columns={columns}
          rows={list.data ?? []}
          rowKey={(c) => c.id}
          loading={list.isPending}
          caption="Concours"
          onRowClick={(c) => navigate(`/selection/${c.id}`)}
          empty={
            <Empty
              icon={<Layers aria-hidden="true" />}
              title="Aucun concours dans votre périmètre"
            />
          }
        />
      </Card>
    </>
  )
}
